$(document).ready(function () {

    if($('#filters').length) {
        if($('#post-loop').length) {

            // Run initial filter
            refilter();

            // Toogle between filter drop downs
            $('#filters .current').on('click', function () {
                // Establish objects
                var col = $(this).parent();
                // If it's already active...
                if(col.hasClass('active')) {
                    // Remove active class to close it
                    col.removeClass('active');
                }
                // Otherwise...
                else {
                    // Close all other filters
                    col.parent().find('.column').removeClass('active');
                    // Open this filter
                    col.addClass('active');
                }
            });

            // On filter item click
            $('#filters ul li').on('click', function() {
                // Establish objects
                var li  = $(this);
                var ul  = li.parent().parent();
                var col = ul.parent();
                // If it's not already selected...
                if(!li.hasClass('selected')) {
                    // Remove selected from old filter
                    ul.find('.selected').removeClass('selected');
                    // Mark this one as selected
                    li.addClass('selected');
                    // Update current item text
                    var newLabel = li.html();
                    col.find('.current').html(newLabel);
                    // Update filter
                    refilter();
                }
                // Close the filter
                col.removeClass('active');
            });

        } else {
            $('#filters').addClass('disabled');
        }
    }
});

// Publications Map
// ------------------------------------------

function refilter() {

    // Establish objects
    var sectors   = $('#filters ul[data-filter="sector"] li.selected');
    var locs      = $('#filters ul[data-filter="location"] li.selected');
    var durations = $('#filters ul[data-filter="duration"] li.selected');
    var fundings  = $('#filters ul[data-filter="funding"] li.selected');
    var stage     = $('#post-loop > .row > .column');
    var courses   = stage.find('.column');
    var fallback  = stage.find('.fallback');

    var params = {};

    // Start by hiding all courses
    courses.addClass('hide');

    // Loop through the courses
    var i;
    for (i = 0; i < courses.length; i++) {

        var sector = loc = duration = funding = false;

        // Loop through the sectors
        var j;
        for (j = 0; j < sectors.length; j++) {
            params['sec'] = $(sectors[j]).attr('data-sector');
            // if the sectors are unfiltered or the article has the sector class...
            if($(sectors[j]).children().hasClass('unfiltered') || $(courses[i]).hasClass('sector-'+$(sectors[j]).attr('data-sector'))) {
                // sector selector says it's good to go
                sector = true;
            }
        }

        // Loop through the locs
        var j;
        for (j = 0; j < locs.length; j++) {
            params['loc'] = $(locs[j]).attr('data-location');
            // if the locs are unfiltered or the article has the loc class...
            if($(locs[j]).children().hasClass('unfiltered') || $(courses[i]).hasClass('location-'+$(locs[j]).attr('data-location'))) {
                // loc selector says it's good to go
                loc = true;
            }
        }

        // Loop through the durations
        var j;
        for (j = 0; j < durations.length; j++) {
            params['dur'] = $(durations[j]).attr('data-duration');
            // if the durations are unfiltered or the article has the duration class...
            if($(durations[j]).children().hasClass('unfiltered') || $(courses[i]).hasClass('duration-'+$(durations[j]).attr('data-duration'))) {
                // duration selector says it's good to go
                duration = true;
            }
        }

        // Loop through the fundings
        var j;
        for (j = 0; j < fundings.length; j++) {
            params['fun'] = $(fundings[j]).attr('data-funding');
            // if the fundings are unfiltered or the article has the funding class...
            if($(fundings[j]).children().hasClass('unfiltered') || $(courses[i]).hasClass('funding-'+$(fundings[j]).attr('data-funding'))) {
                // funding selector says it's good to go
                funding = true;
            }
        }

        // If the sector and loc selectors both say the article is good to go...
        if(sector && loc && duration && funding) {
            // Remove the hide class to show
            $(courses[i]).removeClass('hide');
        }
    }

    // If all the courses are hidden...
    if(courses.length == courses.filter('.hide').length) {
        // Show the fallback
        fallback.removeClass('hide');
    }
    // Otherwise...
    else {
        // Hide the fallback
        fallback.addClass('hide');
        // Reinit equalizer
        Foundation.reInit($('[data-equalizer]'));
    }

    // Update the window URL
    var paramStrings = [];
    for (var key in params) {
        if (params.hasOwnProperty(key) && params[key]) {
            paramStrings.push(key+'='+params[key]);
        }
    }
    window.history.pushState("object or string", document.title, '?'+paramStrings.join('&'));
}
